import React, { FC } from 'react';
import { Dropdown, Menu, Space } from 'antd';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowDown } from 'common/const/svg';
import { ERoute } from 'common/const/enum';
import { useAppDispatch, useAppSelector } from 'common/hooks';

export const Header: FC = () => {
  const { auth } = useAppSelector((state) => ({ auth: state.auth }));
  const { auth: authDispatch } = useAppDispatch();
  const navigate = useNavigate();

  const { data } = auth;
  const { logout } = authDispatch;

  const showContent = !!data;

  const onNavItemClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  return (
    <div className="header">
      <div className="d-flex align-center justify-between header__container">
        {showContent && (
          <>
            <Menu
              className="header__menu"
              selectedKeys={[ERoute.Dashboard]}
              mode="horizontal"
              items={[
                {
                  label: 'Dashboard',
                  key: ERoute.Dashboard,
                },
              ]}
              onClick={onNavItemClick}
            />

            <Dropdown
              menu={{
                items: [
                  {
                    label: 'Log out',
                    key: 'logout',
                    onClick: logout,
                  },
                ],
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <span className="ff-medium fs-md color-white">{data.access?.name}</span>

                  <ArrowDown />
                </Space>
              </a>
            </Dropdown>
          </>
        )}
      </div>
    </div>
  );
};
